import React, { useState } from "react";

const MONATE = ["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"];
const WOCHENTAGE = ["Mo","Di","Mi","Do","Fr","Sa","So"];

export default function Kalender({ besichtigungen = [], betriebsurlaub = [], onDatumSelect, selectedDatum }) {
  const today = new Date();
  const [monat, setMonat] = useState(today.getMonth());
  const [jahr,  setJahr]  = useState(today.getFullYear());

  const belegteDate = besichtigungen
    .filter(b => b.status !== "Abgelehnt")
    .map(b => b.datum?.slice(0, 10));

  const ersterTag  = new Date(jahr, monat, 1);
  const letzterTag = new Date(jahr, monat + 1, 0);

  let startWochentag = ersterTag.getDay() - 1;
  if (startWochentag < 0) startWochentag = 6;

  const tage = [];
  for (let i = 0; i < startWochentag; i++) tage.push(null);
  for (let d = 1; d <= letzterTag.getDate(); d++) tage.push(d);

  const prevMonat = () => {
    if (monat === 0) { setMonat(11); setJahr(j => j - 1); }
    else setMonat(m => m - 1);
  };
  const nextMonat = () => {
    if (monat === 11) { setMonat(0); setJahr(j => j + 1); }
    else setMonat(m => m + 1);
  };

  const formatDatum = (d) => {
    const mm = String(monat + 1).padStart(2, "0");
    const dd = String(d).padStart(2, "0");
    return `${jahr}-${mm}-${dd}`;
  };

  const istVergangenheit = (d) => {
    const datum = new Date(jahr, monat, d);
    datum.setHours(0, 0, 0, 0);
    const h = new Date();
    h.setHours(0, 0, 0, 0);
    return datum < h;
  };

  const istImUrlaub = (d) => {
    const datum = new Date(jahr, monat, d);
    return betriebsurlaub.some(u => {
      const von = new Date(u.urlaubVon);
      const bis = new Date(u.urlaubBis);
      return datum >= von && datum <= bis;
    });
  };

  return (
    <div style={{ background: "white", borderRadius: "12px", padding: "1.25rem", boxShadow: "0 2px 12px rgba(0,0,0,0.08)" }}>
      {/* ── Header ── */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
        <button onClick={prevMonat} style={{ background: "none", border: "none", fontSize: "1.2rem", cursor: "pointer" }}>‹</button>
        <strong style={{ color: "#2e7d32" }}>{MONATE[monat]} {jahr}</strong>
        <button onClick={nextMonat} style={{ background: "none", border: "none", fontSize: "1.2rem", cursor: "pointer" }}>›</button>
      </div>

      {/* ── Wochentage ── */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "4px", marginBottom: "4px" }}>
        {WOCHENTAGE.map(w => (
          <div key={w} style={{ textAlign: "center", fontSize: "0.75rem", fontWeight: 700, color: "#888", padding: "4px 0" }}>{w}</div>
        ))}
      </div>

      {/* ── Tage ── */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "4px" }}>
        {tage.map((d, i) => {
          if (!d) return <div key={i} />;

          const datum    = formatDatum(d);
          const belegt   = belegteDate.includes(datum);
          const vergangen = istVergangenheit(d);
          const urlaub   = istImUrlaub(d);
          const selected = selectedDatum === datum;
          const isToday  = datum === formatDatum(today.getDate()) && today.getMonth() === monat && today.getFullYear() === jahr;

          let bg = "transparent";
          let color = "#333";
          let cursor = "pointer";
          let border = "1px solid transparent";

          if (vergangen) { bg = "#f5f5f5"; color = "#ccc"; cursor = "default"; }
          if (belegt)    { bg = "#ffebee"; color = "#c62828"; cursor = "default"; }
          if (urlaub)    { bg = "#ede7f6"; color = "#6a1b9a"; cursor = "default"; }
          if (selected)  { bg = "#2e7d32"; color = "white"; }
          if (isToday && !selected) border = "2px solid #2e7d32";

          return (
            <div key={i}
              onClick={() => !belegt && !vergangen && !urlaub && onDatumSelect && onDatumSelect(datum)}
              style={{
                textAlign: "center", padding: "6px 2px", borderRadius: "8px",
                fontSize: "0.85rem", fontWeight: isToday ? 700 : 400,
                background: bg, color, cursor, border,
                transition: "background 0.15s"
              }}
              title={belegt ? "Bereits belegt" : urlaub ? "Betriebsurlaub" : vergangen ? "" : "Datum wählen"}
            >
              {d}
              {belegt && <div style={{ fontSize: "0.55rem", marginTop: "1px" }}>●</div>}
              {urlaub && <div style={{ fontSize: "0.55rem", marginTop: "1px" }}>🏖</div>}
            </div>
          );
        })}
      </div>

      {/* ── Legende ── */}
      <div style={{ display: "flex", gap: "1rem", marginTop: "1rem", fontSize: "0.8rem", color: "#666", flexWrap: "wrap" }}>
        <span><span style={{ color: "#c62828" }}>●</span> Belegt</span>
        <span><span style={{ color: "#6a1b9a" }}>●</span> Betriebsurlaub</span>
        <span><span style={{ color: "#2e7d32" }}>■</span> Ausgewählt</span>
      </div>
    </div>
  );
}
